import React from 'react'
import PropTypes from 'prop-types'
import reduce from 'lyjs/es/fp/reduce'

import {numberLabelFormatter} from 'services/formatters/numberFormatter'
import {percentLabelFormatter} from 'services/formatters/percentFormatter'
import axis from 'components/Chart/axies/axis'
import timeAxis from 'components/Chart/axies/time'
import AutoSizeChart from 'components/AutoSizeChart'
import TimelineChart from 'components/TimelineChart'

function FeatsTimelineChart(props) {
  const {
    option: optionProp = {},
    yAxisName,
    ...otherProps,
  } = props

  const {
    legendData,
    series
  } = reduce((result, x) => {
    const {
      name,
      yAxisIndex
    } = x

    result.legendData.push(name)
    result.series.push({
      label: {
        emphasis: {
          show: true,
          position: 'top',
          formatter: yAxisIndex === 1 ? percentLabelFormatter : numberLabelFormatter
        }
      },
      ...x,
    })

    return result
  }, {
    legendData: [],
    series: []
  }, optionProp.series || [])

  const option = {
    ...optionProp,
    grid: {
      top: 96,
      ...optionProp.grid
    },
    yAxis: axis(yAxisName),
    legend: {
      top: 32,
      data: legendData,
      ...optionProp.legend
    },
    series
  }

  const media = [{
    query: {
      maxWidth: 736
    },
    option: {
      grid: {
        top: 120
      }
    }
  }, {
    query: {
      maxWidth: 393
    },
    option: {
      grid: {
        top: 140
      },
      xAxis: timeAxis({
        format: 'HH'
      })
    }
  }, {
    query: {
      maxWidth: 288
    },
    option: {
      grid: {
        top: 164
      }
    }
  }]

  return (
    <TimelineChart
      {...otherProps}
      component={AutoSizeChart}
      option={option}
      media={media}
    />
  )
}
FeatsTimelineChart.defaultProps = {
  xAxisName: '时间',
  yAxisName: '次数',
  format: 'HH:mm'
}

if (process.env.NODE_ENV !== 'production') {
  FeatsTimelineChart.propTypes = {
    option: PropTypes.object,
    xAxisName: PropTypes.string,
    yAxisName: PropTypes.string,
    format: PropTypes.string
  }
}

export default FeatsTimelineChart



// WEBPACK FOOTER //
// ./src/scenes/Main/components/FeatsTimelineChart/FeatsTimelineChart.js